"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgUsers(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M7.289 3a5.115 5.115 0 012.18 9.743c2.939.885 5.11 3.498 5.11 6.485v.483a.766.766 0 01-.767.766H.766A.766.766 0 010 19.711v-.483c0-2.988 2.17-5.6 5.11-6.486A5.115 5.115 0 017.289 3zm0 10.954c-3 0-5.502 2.22-5.739 4.864l-.009.126h11.495l-.008-.126c-.231-2.577-2.612-4.75-5.51-4.86zM17.436 3a4.39 4.39 0 012.031 8.283c2.54.794 4.426 3.025 4.529 5.603l.004.221v.43a.766.766 0 01-.662.759l-.104.006h-7.248a.766.766 0 01-.104-1.524l.104-.007 6.466-.001-.005-.07c-.226-2.217-2.28-4.083-4.783-4.19l-.228-.006a5.23 5.23 0 00-3.177 1.066.766.766 0 01-.929-1.218 6.728 6.728 0 012.073-1.07A4.39 4.39 0 0117.436 3zM7.289 4.532a3.583 3.583 0 10.001 7.167 3.583 3.583 0 00-.001-7.167zm10.147 0a2.857 2.857 0 10-.001 5.715 2.857 2.857 0 00.001-5.715z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgUsers;
exports.default = _default;